var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompany = function SvgCompany(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "company_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#company_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8C9194",
    d: "M2.366 20.577V4.327L7.116.885l4.75 3.442v2.75h9.769v13.5zm1.5-1.5h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm0-4h2.5v-2.5h-2.5zm4 0h2.5v-2.5h-2.5zm0 12h12.269v-10.5H7.865zm6.192-6.5v-1.5h3.692v1.5zm0 4v-1.5h3.692v1.5zm-3.692-4v-1.5h1.5v1.5zm0 4v-1.5h1.5v1.5z"
  }))));
};
export default SvgCompany;